import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-vermoegen',
  templateUrl: './vermoegen.component.html',
  styleUrls: ['./vermoegen.component.scss']
})
export class VermoegenComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
